//普通优惠券
export const COMMON_TYPE_CONPON = 0;

//上不封顶优惠券
export const UNLIMITED_TYPE_COUPON = 1;

//红包券
export const REDPACKET_TYPE_COUPON = 2;

//折扣券
export const DISCOUNT_TYPE_COUPON = 3;

//邮费券
export const POSTAGE_TYPE_COUPON = 4;

//平台类型
export const COMMON_VARIETY_COUPON = 0;

//品类类型
export const CATEGORY_VARIETY_COUPON = 3;

//品牌类型
export const BRAND_VARIETY_COUPON = 6;

//SKU类型
export const SKU_VARIETY_COUPON = 8;

//邮费类型
export const POSTAGE_VARIETY_COUPON = 9;
